import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "./components/ui/sonner";
import Nav from "./components/site/Nav";
import Footer from "./components/site/Footer";
import AnalyticsRouteTracker from "./analytics/AnalyticsRouteTracker";
import HomePage from "./pages/HomePage";
import ReviewPage from "./pages/ReviewPage";
import HubPage from "./pages/HubPage";
import GuidePage, { GuidesIndexPage } from "./pages/GuidePage";
import QuizPage from "./pages/QuizPage";
import { AboutPage, PrivacyPage, DisclosurePage, ResourcesPage, NotFoundPage } from "./pages/StaticPages";

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 150);
      return () => clearTimeout(t);
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

function App() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);

  return (
    <div className="App grain">
      <BrowserRouter>
        <ScrollManager />
        <AnalyticsRouteTracker />
        <Nav />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/reviews/:slug" element={<ReviewPage />} />
          <Route path="/best/:slug" element={<HubPage />} />
          <Route path="/guides" element={<GuidesIndexPage />} />
          <Route path="/guides/:slug" element={<GuidePage />} />
          <Route path="/quiz" element={<QuizPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/privacy-policy" element={<PrivacyPage />} />
          <Route path="/affiliate-disclosure" element={<DisclosurePage />} />
          <Route path="/resources" element={<ResourcesPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        <Footer />
      </BrowserRouter>
      <Toaster theme="dark" />
    </div>
  );
}

export default App;
